import BlokWrap from "@/components/ui/BlokWrap";
import { StandoutTextStoryblok } from "@/generated/sb/sb-types";
import { BlokProps } from "@frend-digital/storyblok";
import clsx from "clsx";
import styles from "./index.module.css";

export const StandoutText = ({
  blok,
  column,
}: BlokProps<StandoutTextStoryblok> & {
  column?: boolean;
}) => {
  return (
    <BlokWrap animated="fadeY" editorial editable={blok}>
      <div
        className={clsx(
          styles.wrapper,
          blok.title && styles.hasTitle,
          column && styles.column,
        )}
        data-layout="page"
      >
        {blok.title && <h2>{blok.title}</h2>}
        <div className={styles.inner}>{blok.text && <p>{blok.text}</p>}</div>
      </div>
    </BlokWrap>
  );
};
